import React, { useContext } from 'react';
import { IoArrowForward } from 'react-icons/io5';
import styled from 'styled-components';
import { CartContext } from '../context/CartContext';

const Button = styled.button`
  border:2px solid rgba(77,75,50,0.72);
  padding:10px;
  border-radius:5px;
  color:white;
  width:100%;
  margin-top:10px;
  font-size:16px;
  border:1px solid rgba(77,75,50,0.72);
  &:hover{
    cursor:pointer;
    color:black;
    background:${props => props.bgColor ? props.bgColor : '#FCDA8B'};
    box-shadow: 0px 0px 6px 5px rgba(77,75,50,0.72);
    border:1px solid #FCDA8B;
    transition: all 0.3s ease-in;
  }
  &:active{
    transform:scale(0.9);
  }
`

function Modal({userInfo, isOpen, setIsOpen, data, setData}) {
  const {setClicked} = useContext(CartContext)
  const toggleModal = () => {
    setIsOpen(!isOpen);
  }

  const submitHandler = (e) => {
    e.preventDefault();
    setClicked(true)
  }

  return (
    <>
      <button onClick={toggleModal} className='close-btn'>Checkout <IoArrowForward color='black' style={{backgroundColor:'transparent'}}/></button>

      {isOpen && (
        <div className="modal-overlay">
          <form onSubmit={submitHandler} className="modal" style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
            <input className='input' type='text' required value={data.fullName} onChange={(e)=>setData({...data, fullName:e.target.value})} placeholder='Full Name'/>
            <input className='input' type='email' required value={data.email} onChange={(e)=>setData({...data, email:e.target.value})} placeholder='Email'/>
            <input className='input' type='number' required value={data.number} onChange={(e)=>setData({...data, number:e.target.value})} placeholder='Mobile Number'/>
            <textarea style={{color:'white'}} className='input' required value={data.address} onChange={(e)=>setData({...data, address:e.target.value})} placeholder='address' />
            <Button className='input'>Submit</Button>
            <Button className='input' bgColor='transparent' style={{color:'white', border:'0px'}} onClick={toggleModal}>Close</Button>
          </form>
        </div>
      )}
    </>
  );
}

export default Modal;
